var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"file","name":"image","accept":"image/*","capture":"environment"},on:{"change":_vm.onChangeInput}})}
var staticRenderFns = []

export { render, staticRenderFns }